module.exports = __webpack_public_path__ + "static/images/fitness-hero.76660578b6fea40290e991ef1e559de5.png";